import { Component } from '@angular/core';


export class SkyCheckboxLabelComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-checkbox-label',
  template: `<ng-content></ng-content>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
